var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7197 0L7 1.68366L0 9.30073L0.677419 16.0968L2.10677 18H10.2358L13.1148 14.8083L14 3.80415L12.7197 0Z",
    fill: "url(#paint0_linear_12802_45923)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 9.30078L0.677419 16.0969L2.10677 18L4.25645 14.2091L0 9.30078Z",
    fill: "url(#paint1_linear_12802_45923)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M4.2571 14.2091L2.10742 18.0001H10.2365L13.1155 14.8084L10.9748 7.84326L4.2571 14.2091Z",
    fill: "url(#paint2_linear_12802_45923)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M12.7201 0L10.9746 7.84317L13.1153 14.8083L14.0004 3.80415L12.7201 0Z",
    fill: "url(#paint3_linear_12802_45923)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7206 0L7.61064 2.07659L3.39258 5.61073L7.00097 1.68366L12.7206 0Z",
    fill: "url(#paint4_linear_12802_45923)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10742 18L4.2571 14.209L3.49613 16.3163L2.98807 17.0978L2.89549 18H2.10742Z",
    fill: "#688986"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9746 7.84326L12.8036 13.7942L12.3407 11.643L12.0472 10.9845L11.6994 9.37546L10.9746 7.84326Z",
    fill: "#688986"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M8.87134 9.83616L5.27199 3.5625L2.50586 6.57421L6.88876 11.7152L7.66102 17.9998H9.77005L8.87134 9.83616Z",
    fill: "url(#paint5_linear_12802_45923)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M13.6162 8.58087L11.8097 4.09843L9.68716 0.893555L7.00006 1.6838L6.43555 2.29843L11.2317 6.69307L13.3294 12.1304L13.6162 8.58087Z",
    fill: "url(#paint6_linear_12802_45923)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7196 0L11.8887 0.338049L12.4374 1.27317L14 3.80415L12.7196 0Z",
    fill: "url(#paint7_linear_12802_45923)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12802_45923",
    x1: 4.83226,
    y1: -0.656342,
    x2: 9.70038,
    y2: 21.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#048529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12802_45923",
    x1: 3.01452,
    y1: 18.2174,
    x2: 1.38371,
    y2: 8.54331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B9673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAFFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12802_45923",
    x1: 3.64065,
    y1: -0.388446,
    x2: 8.50877,
    y2: 21.4033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAB789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAFFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12802_45923",
    x1: 11.0965,
    y1: 12.4902,
    x2: 15.3899,
    y2: -0.20704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B9673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAFFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12802_45923",
    x1: 4.92355,
    y1: 6.18805,
    x2: 10.4473,
    y2: -0.139913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FF87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12802_45923",
    x1: 10.9781,
    y1: 7.42152,
    x2: 4.94394,
    y2: 13.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12802_45923",
    x1: 12.6362,
    y1: 3.22697,
    x2: 9.37963,
    y2: 8.21392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12802_45923",
    x1: 13.5416,
    y1: 3.97537,
    x2: 12.4353,
    y2: 0.243765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5FF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FF87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.e788ea1287a2e7eba3e1e95b47970e3f.svg";
export { ForwardRef as ReactComponent };